import { viewerTimeZone } from './useOpsOnDuty';

import type { OnDutyData, OnDutyEntry } from '@/services/opsRota/types';

// Which of the bar's two states to show (GRAVY-10878 "States").
//   hidden: nobody on duty right now, whether or not anyone is scheduled,
//           or no response yet, or an error/404 (graphy may not have the
//           endpoint yet). The bar comes back on the poll that finds someone.
//   roster: at least one person on duty; off-duty people stay listed as OFF.
//           `timeZone` is set when graphy answered for another zone than the
//           viewer's (it falls back to the agency zone): "today" is
//           that zone's, so times show in it too.
export type BarState =
  | { kind: 'hidden' }
  | { kind: 'roster'; entries: OnDutyEntry[]; timeZone?: string };

export const barState = (data: OnDutyData | undefined): BarState => {
  if (!data?.entries.some((entry) => entry.on_duty)) {
    return { kind: 'hidden' };
  }
  const zone = data.meta.time_zone;
  return {
    kind: 'roster',
    entries: data.entries,
    timeZone: zone && zone !== viewerTimeZone() ? zone : undefined,
  };
};
